import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IEmendaParlamentarPagedResponse } from "models/response/emenda-parlamentar-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type EmendasParlamentaresTableProps = {
    currentItems: PaginationResponse<IEmendaParlamentarPagedResponse>;
};

export const EmendasParlamentaresTable: React.FC<EmendasParlamentaresTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhuma emenda parlamentar encontrada.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nº Emenda</TableCell>
                        <TableCell>Autor</TableCell>
                        <TableCell>Modalidade</TableCell>
                        <TableCell>Forma de Repasse</TableCell>
                        <TableCell>Tipo de Origem</TableCell>
                        <TableCell>Exercício</TableCell>
                        <TableCell align="right">V. Previsto</TableCell>
                        <TableCell align="right">V. Realizado</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((emenda) => (
                        <TableRow key={emenda.id}>
                            <TableCell>{emenda.numeroEmenda}</TableCell>
                            <TableCell>{emenda.nomAutor}</TableCell>
                            <TableCell>
                                <Chip label={emenda.tipoEmendaName} size="small" style={getCategoryColor(emenda.tipoEmendaName)} />
                            </TableCell>
                            <TableCell>{emenda.formaRepasseEmendaName}</TableCell>
                            <TableCell>{emenda.tipoOrigem}</TableCell>
                            <TableCell>{emenda.ano}</TableCell>
                            <TableCell align="right">
                                {emenda.valorPrevisto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="right">
                                {emenda.valorRealizado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/emendas-parlamentares/${emenda.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
